<template>
  <div :class="{ 'has-error': !!errorMessage, success: meta.valid }" class="flex flex-col gap-1">
    <label class="font-semibold" :for="name">
      {{ label }}<span v-if="required" class="text-red-600">*</span>
    </label>

    <select
      :id="name"
      :name="name"
      :placeholder="placeholder"
      :required="required"
      v-model="inputValue"
      @blur="handleBlur"
      class="rounded border px-5 py-3"
    >
      <option disabled value="">-</option>
      <option v-for="(el, idx) in options" :key="idx" :value="el.id">{{ el.name }}</option>
    </select>

    <p v-show="errorMessage || meta.valid" class="help-message text-red-500">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import { toRef } from 'vue';
import { useField } from 'vee-validate';
import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export default {
  props: {
    type: { type: String, default: 'text' },
    value: { type: [String, Number], default: undefined },
    name: { type: String, required: true },
    label: { type: String, required: true },
    successMessage: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    required: { type: Boolean, default: true },
    property: { type: Number, default: undefined },
    defaultSelectValue: { type: Object, default: undefined },
    // может не передаваться — но пусть будет, чтобы не было undefined в emit
    dataType: { type: Number, default: 4 },
  },
  setup(props) {
    const { t } = useI18n();
    const name = toRef(props, 'name');

    let rules = yup.number();
    if (props.required) rules = rules.required(t('warning.REQUIRED_MESSAGE'));

    const defaultValue = props?.defaultSelectValue?.id ?? '';

    const { meta, value, errorMessage, validate, handleBlur } = useField(name, rules, {
      initialValue: defaultValue,
    });

    // ✅ не делаем ref(ref()) — value уже ref
    const inputValue = value;

    return { inputValue, errorMessage, validate, meta, handleBlur };
  },
  methods: {
    emitValue() {
      const v =
        this.inputValue && typeof this.inputValue === 'object' && 'value' in this.inputValue
          ? this.inputValue.value
          : this.inputValue;

      this.$emit('valueChanged', {
        value: v,
        property: this.property,
        level: 1,
        data_type: this.dataType,
      });
    },
    async validateField() {
      const validatedData = await this.validate();

      const v =
        this.inputValue && typeof this.inputValue === 'object' && 'value' in this.inputValue
          ? this.inputValue.value
          : this.inputValue;

      // ✅ ВАЖНО: всегда возвращаем массив для select_values
      const arr = v === undefined || v === null || String(v).trim() === '' ? [] : [v];
      return { value: arr, valid: validatedData.valid, mode: 'multi', property: this.property };
    },
  },
  watch: {
    inputValue() {
      this.emitValue();
    },
  },
};
</script>

<style scoped>
/* Your styles here */
</style>
